import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { create } from 'zustand';

import { db } from './firebase';

export const useSession = create(() => ({
  ready: false, // true once we know whether this is a guest or a signed-in user
  user: null, // { uid, email } for signed-in users, null for guests
  username: '',
  membershipStatus: 'Basic',
  hasLicense: false, // valid school license code in this browser
}));

export const selectIsPremium = (s) => s.membershipStatus !== 'Basic' || s.hasLicense;
export const usePremium = () => useSession(selectIsPremium);

let started = false;

export const initSession = () => {
  if (started) return;
  started = true;

  // School license codes unlock everything for the students using them
  const code = localStorage.getItem('school_code');
  if (code) {
    getDoc(doc(db, 'licenses', code.trim()))
      .then((snap) => useSession.setState({ hasLicense: snap.exists() }))
      .catch(() => {});
  }

  let unsubDoc = null;
  onAuthStateChanged(getAuth(), (user) => {
    if (unsubDoc) {
      unsubDoc();
      unsubDoc = null;
    }

    if (!user) {
      useSession.setState({ ready: true, user: null, username: '', membershipStatus: 'Basic' });
      return;
    }

    useSession.setState({ user: { uid: user.uid, email: user.email } });
    unsubDoc = onSnapshot(
      doc(db, 'users', user.uid),
      (snap) => {
        const data = snap.exists() ? snap.data() : {};
        useSession.setState({
          ready: true,
          username:
            data.username || user.displayName || (user.email || '').split('@')[0] || 'Player',
          membershipStatus: data.membershipStatus || 'Basic',
        });
      },
      () => useSession.setState({ ready: true }),
    );
  });
};